import React, { useState } from 'react';

const Rooms = ({ formData }) => {
  const [description, setDescription] = useState('');
  const [charLimit] = useState(500);
  const [baseAdults, setBaseAdults] = useState(1);

  const handleDescriptionChange = (e) => {
    const value = e.target.value;
    if (value.length <= charLimit) {
      setDescription(value);
    }
  };

  const handleIncrement = (value, setter, max = 10) => {
    if (value < max) {
      setter(value + 1);
    }
  };

  const handleDecrement = (value, setter, min = 1) => {
    if (value > min) {
      setter(value - 1);
    }
  };

  return (
    <div>
        <div className="clp-header">
            <h4 className='ws-title'>Rooms</h4>
            <p className="ws-desc">Define Rooms available at your property and the amenities for each type of room</p>
        </div>

        <div className="add-room-section hmfsb">

          <div className="room-detail-box">

            <div className="adrotibx">
              <h4 className='ws-title'>Rooms</h4>
              <p className="ws-desc mb-3">Add room level details</p>
            </div>
            
            <div className='row'>
              <div className='col-md-6'>
                <div className="form-box">
                  <label for="roomName" class="form-label">Room Name</label>
                  <input type="text" class="form-control" id="roomName" placeholder="Room Name" />
                </div>
              </div>
            </div>

            <div className='row'>
              <div className='col-md-12'>
                <div className='form-box'>
                  <label for="roomDesc" class="form-label">Room Description</label>
                  <textarea
                    className='form-control'
                    id='roomDesc'
                    rows={5}
                    value={description}
                    onChange={handleDescriptionChange}
                  />
                  <div className='hhtbs'>
                  {charLimit - (description?.length || 0)} characters available
                  </div>
                </div>
              </div>
            </div>

            <div className='row'>
              <div className='col-md-6'>
                <div class="form-box">
                  <label for="roomCount" class="form-label">Number of Available Room(s)</label>
                  <input type="text" class="form-control" id="roomCount" placeholder="Enter Room Count" />
                </div>
              </div>
            </div>

            <div className='row'>
              <div className='col-md-6'>
                <div class="form-box">
                  <label for="roomCount" class="form-label">Meal Options</label>
                  <select class="form-select">
                      <option selected>select</option>
                      <option value="1">Accomodation only</option>
                      <option value="2">Free Breakfast</option>
                  </select>
                </div>
              </div>
            </div>

            <div className='row'>
              <div className='col-md-6'>
                <div class="form-box">
                  <label for="roomCount" class="form-label">Room Type</label>
                  <select class="form-select">
                      <option selected>select</option>
                      <option value="1">Deluxe</option>
                      <option value="2">Standard</option>
                  </select>
                </div>
              </div>
              <div className='col-md-6'>
                <div class="form-box">
                  <label for="roomCount" class="form-label">Bed Type</label>
                  <select class="form-select">
                      <option selected>select</option>
                      <option value="1">king Bed</option>
                      <option value="2">Queen Bed</option>
                  </select>
                </div>
              </div>
            </div>

            <div className='row'>
              <div className='col-md-6'>
                <div class="form-box">
                  <label for="roomCount" class="form-label">Room Size (Area)</label>
                  <select class="form-select">
                      <option selected>select</option>
                      <option value="1">Deluxe</option>
                      <option value="2">Standard</option>
                  </select>
                </div>
              </div>
              <div className='col-md-6'>
                <div class="form-box">
                  <label for="roomCount" class="form-label">Room View (Optional)</label>
                  <select class="form-select">
                      <option selected>select</option>
                      <option value="1">Sea View</option>
                      <option value="2">Hill View</option>
                  </select>
                </div>
              </div>
            </div>

            <div className='row'>
              <div className='col-md-6'>
                <div class="form-box">
                  <label for="roomCount" class="form-label">Smoking Allowed</label>
                  <select class="form-select">
                      <option value="1">No</option>
                      <option value="2">Yes</option>
                  </select>
                </div>
              </div>
            </div>

          </div>

          <div className="room-detail-box">
            <div>
              <p className='rdb-title'>Extra Bed</p>
            </div>
            <div className='dypxbs'>
              <div>
                <p>Do you provide extra bed?</p>
              </div>
              <div class="extra-bed-radio">
                <div className='exdrs'>
                  <label>
                    <input type="radio" name="radio" checked="" />
                    <span>No</span>
                  </label>
                  <label>
                    <input type="radio" name="radio" />
                    <span>Yes</span>
                  </label>
                </div>
              </div>
            </div>
            <div className='row'>
              <div className='col-md-6'>
                <div class="form-box">
                  <label for="extraBed" class="form-label">Extra Bed Type</label>
                  <select class="form-select">
                      <option selected>select</option>
                      <option value="1">Mattress</option>
                      <option value="2">Cot</option>
                      <option value="3">Sofa Cum Bed</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div className="room-detail-box">
            <div>
              <p className='rdb-title'>Room Occupancy</p>
            </div>
            <div className='row'>
              <div className='col-md-12'>
                <div className='house-rules-box pt-0'>
                  <div className='rules-guest-box'>
                    <div className='hrbss'>
                      <label className='st1-label'>Base Adults</label>
                      <p className='label-hint'>Ideal number of adults that can be accomodated in this room. Occupancy calculations are based on the accommodation of two adults per room.</p>
                    </div>
                    <div className="input-number-container">
                        <span className="input-number-decrement" onClick={() => handleDecrement(baseAdults, setBaseAdults)}>–</span>
                        <input
                            name='guest'
                            className="input-number"
                            type="number"
                            value={baseAdults}
                            readOnly
                        />
                        <span className="input-number-increment" onClick={() => handleIncrement(baseAdults, setBaseAdults)}>+</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className='col-md-12'>
                <div className='house-rules-box'>
                  <div className='rules-guest-box'>
                    <div className='hrbss'>
                      <label className='st1-label'>Maximum Adults</label>
                      <p className='label-hint'>Maximum number of adults that can be accommodated in this room. Occupancy calculations are determined by the accommodation of two adults in a room, without the addition of extra beds.</p>
                    </div>
                    <div className="input-number-container">
                        <span className="input-number-decrement" onClick={() => handleDecrement(baseAdults, setBaseAdults)}>–</span>
                        <input
                            name='guest'
                            className="input-number"
                            type="number"
                            value={baseAdults}
                            readOnly
                        />
                        <span className="input-number-increment" onClick={() => handleIncrement(baseAdults, setBaseAdults)}>+</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className='col-md-12'>
                <div className='house-rules-box'>
                  <div className='rules-guest-box'>
                    <div className='hrbss'>
                      <label className='st1-label'>Maximum Children</label>
                      <p className='label-hint'>Mention the number of maximum children who are allowed to stay in the room</p>
                    </div>
                    <div className="input-number-container">
                        <span className="input-number-decrement" onClick={() => handleDecrement(baseAdults, setBaseAdults)}>–</span>
                        <input
                            name='guest'
                            className="input-number"
                            type="number"
                            value={baseAdults}
                            readOnly
                        />
                        <span className="input-number-increment" onClick={() => handleIncrement(baseAdults, setBaseAdults)}>+</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className='col-md-12'>
                <div className='house-rules-box'>
                  <div className='rules-guest-box'>
                    <div className='hrbss'>
                      <label className='st1-label'>Maximum Occupancy</label>
                      <p className='label-hint'>Specify the maximum number of adults & children that can be accommodated in this room</p>
                    </div>
                    <div className="input-number-container">
                        <span className="input-number-decrement" onClick={() => handleDecrement(baseAdults, setBaseAdults)}>–</span>
                        <input
                            name='guest'
                            className="input-number"
                            type="number"
                            value={baseAdults}
                            readOnly
                        />
                        <span className="input-number-increment" onClick={() => handleIncrement(baseAdults, setBaseAdults)}>+</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="room-detail-box">
            <div>
              <p className='rdb-title'>Base Room Price</p>
            </div>
            <div className='row'>
              <div className='col-md-6'>
                <div class="form-box">
                  <label for="baseRate" class="form-label">Base Rate</label>
                  <input type="text" class="form-control" id="baseRate" placeholder="Add Rate" />
                </div>
              </div>
              <div className='col-md-6'>
                <div class="form-box">
                  <label for="extraAdultCharge" class="form-label">Extra Adult Charge (Optional)</label>
                  <input type="text" class="form-control" id="extraAdultCharge" placeholder="Add Rate" />
                </div>
              </div>
            </div>
            <div className='row'>
              <div className='col-md-6'>
                <div class="form-box">
                  <label for="childCharges" class="form-label">Charges for child (7-17 yrs) (Optional)</label>
                  <input type="text" class="form-control" id="childCharges" placeholder="Add Rate" />
                </div>
              </div>
            </div>
          </div>

          <div className="room-detail-box">
            <div>
              <p className='rdb-title mb-0'>Availability</p>
              <p className='label-hint'>Please select the start & end dates on which your property can be booked by guests.</p>
            </div>
            <div className='row'>
              <div className='col-md-6'>
                <div class="form-box">
                  <label for="startDate" class="form-label">Start Date</label>
                  <input type="date" class="form-control" id="startDate" />
                </div>
              </div>
              <div className='col-md-6'>
                <div class="form-box">
                  <label for="endDate" class="form-label">End Date</label>
                  <input type="date" class="form-control" id="endDate"/>
                </div>
              </div>
            </div>
          </div>

          <div className="room-detail-box">
            <div>
              <p className='rdb-title mb-0'>Room Amenities</p>
              <p className='label-hint'>Answering the amenities available at your property can significantly influence guests to book! Please answer the <strong>Mandatory Amenities</strong> available below</p>
            </div>
          </div>

        </div>
    </div>
  );
};

export default Rooms;
